import React from "react";

interface TruncateTextProps {
  text: string;
  maxLength: number;
}

const truncate = (str: string, length: number): string => {
  return str.length <= length ? str : str.substring(0, length) + "...";
};

const TruncateText: React.FC<TruncateTextProps> = ({ text, maxLength }) => {
  return <span>{truncate(text, maxLength)}</span>;
};

export default TruncateText;
